import React from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
// import { faHome } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PageHeader from 'components/common/PageHeader';
import {Link} from 'react-router-dom'


const FaseB = () => {

  return (<>
    <PageHeader
    title="Fase B EFRAG"
    description="IDENTIFICAZIONE AZIENDA RISCHI E AZIONI/KPI DI MITIGAZIONE RISCHI"
    className="mb-3"
    >
    </PageHeader>
    
    <Card key="CRITERI"  style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
          <Card.Title>
            <h5 className="text-info fw-medium mb-0"  style={{marginBottom:"3%"}}>Criteri</h5>
          </Card.Title>
          <Card.Text>
          <ul style={{listStyleType:"none"}}>
            <li key="ALL07">
          <Link to="scheda-07">
            SCHEDA 7 – CRITERI IDENTIFICAZIONE PERIODO E UNITÀ DI MISURA VALORI 
            <FontAwesomeIcon icon="chevron-right" className="ms-1 fs-11" />
          </Link> 
          </li>

          <li key="ALL08">
          <Link to="scheda-08">
            SCHEDA 8 – CRITERI IDENTIFICAZIONE RISCHI E MITIGAZIONI
            <FontAwesomeIcon icon="chevron-right" className="ms-1 fs-11" />
          </Link> 
          </li>

          </ul>
          </Card.Text>
        </Card.Body>
      </Card>

      <Card key="SCHEMI"  style={{marginTop:"2%", marginBottom:"2%"}}>
        <Card.Body>
          <Card.Title>
          <h5 className="text-primary mb-0" style={{marginBottom:"3%"}}><span className="text-info fw-medium">Schemi</span></h5>
          </Card.Title>
          <Card.Text>
          <ul style={{listStyleType:"none"}}>
            <li key="ALL09">
          <Link to="scheda-09">
            SCHEDA 9 – SCHEMA UNIFICATO INPUT PARTE IDENTIFICAZIONE RISCHI – MITIGAZIONI  
            <FontAwesomeIcon icon="chevron-right" className="ms-1 fs-11" />
          </Link> 
          </li>
          </ul>
          </Card.Text>
        </Card.Body>
      </Card>

    </>)
};

export default FaseB;
